export enum WebEntryActionType {
  InvalidateCache = '@quidproquo-webserver/WebEntry/InvalidateCache',
}
